<template>
  <v-content>
    <QuoteQuestionsHeader title="Transfer of equity"/>
    <QuoteQuestions quoteTypeId="4"/>
  </v-content>
</template>

<script>
import QuoteQuestionsHeader from "@/components/QuoteQuestionsHeader";
import QuoteQuestions from "@/components/QuoteQuestions";
export default {
  name: "Transfer",
  components: { QuoteQuestionsHeader, QuoteQuestions }
};
</script>

<style></style>